import { administration } from './administration';
import { administrationPage } from './administrationPage';
import { aiSearch } from './aiSearch';
import { alerts } from './alerts';
import { billingHolds } from './billingHolds';
import { careManagement } from './careManagement';
import { ccm } from './ccm';
import { chartReview } from './chartReview';
import { claims } from './claims';
import { common } from './common';
import { company } from './company';
import { devices } from './devices';
import { diagnoses } from './diagnoses';
import { followUpTasks } from './followUpTasks';
import { globalLookup } from './globalLookup';
import { home } from './home';
import { login } from './login';
import { medRec } from './medRec';
import { messaging } from './messaging';
import { mockApis } from './mockApis';
import { notifications } from './notifications';
import { patientEmail } from './patientEmail';
import { patientSchedules } from './patientSchedules';
import { patientsLookup } from './patientsLookup';
import { patientsPage } from './patientsPage';
import { providerApprovals } from './providerApprovals';
import { providers } from './providers';
import { providersPage } from './providersPage';
import { reportsCommunication } from './reportsCommunication';
import { reportsPage } from './reportsPage';
import { requests } from './requests';
import { rpm } from './rpm';
import { switchCompany } from './switchCompany';
import { tasks } from './tasks';
import { tcm } from './tcm';
import { transferPatient } from './transferPatient';
import { upload } from './upload';
import { visitReminders } from './visitReminders';

export const en = {
  billingHolds,
  common,
  company,
  mockApis,
  providers,
  administration,
  careManagement,
  claims,
  chartReview,
  patientSchedules,
  patientsLookup,
  devices,
  diagnoses,
  followUpTasks,
  providerApprovals,
  reportsCommunication,
  alerts,
  home,
  switchCompany,
  notifications,
  requests,
  tasks,
  login,
  medRec,
  messaging,
  globalLookup,
  transferPatient,
  upload,
  tcm,
  ccm,
  providersPage,
  rpm,
  patientsPage,
  reportsPage,
  administrationPage,
  aiSearch,
  visitReminders,
  patientEmail
} as const;
